import { createFileRoute, redirect } from "@tanstack/react-router";

// Conventional alias for the privacy policy (Builder page at
// /page/privacy-policy).
export const Route = createFileRoute("/_public/privacy")({
  beforeLoad: () => {
    throw redirect({
      to: "/page/$name",
      params: { name: "privacy-policy" },
      statusCode: 301,
    });
  },
  component: () => null,
  staticData: { title: "Privacy Policy" },
});
